export const DocumentoTipo = Object.freeze({
  RICEVUTA: "RICEVUTA",
  REFERTO: "REFERTO",
  ALTRO: "ALTRO",
});

export const documentoShape = {
  id: "",
  tipo: DocumentoTipo.RICEVUTA,
  nomeFile: "",
  url: "",
  createdAt: "",
};

export const createDocumentoModel = (overrides = {}) => ({
  ...documentoShape,
  ...overrides,
});

